// Kort-rutnät med nyckeltal för en aktie.

import { fmtMarketCap, fmtNumber, rsiLabel, rsiStyle } from '../../lib/format';
import type { Stock } from '../../types/stock';

interface Props {
  stock: Stock;
}

interface Stat {
  label: string;
  value: string;
  className?: string;
}

export default function KeyStats({ stock }: Props) {
  const stats: Stat[] = [
    {
      label: 'P/E',
      value: fmtNumber(stock.pe_ratio, { maximumFractionDigits: 1 }),
    },
    {
      label: 'Direktavkastning',
      value:
        stock.dividend_yield !== undefined && stock.dividend_yield !== 0
          ? `${stock.dividend_yield.toFixed(2)} %`
          : '—',
    },
    {
      label: 'Börsvärde',
      value: fmtMarketCap(stock.market_cap),
    },
    {
      label: 'RSI(14)',
      value: rsiLabel(stock.rsi_14),
      className: rsiStyle(stock.rsi_14),
    },
    {
      label: 'Sektor',
      value: stock.sector || '—',
    },
    {
      label: 'Land',
      value: stock.country || '—',
    },
    {
      label: 'Senast uppdaterad',
      value: stock.last_updated ? new Date(stock.last_updated).toLocaleString('sv-SE') : '—',
    },
  ];

  return (
    <dl className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
      {stats.map((s) => (
        <div
          key={s.label}
          className="rounded border border-slate-200 bg-white p-3 dark:border-slate-800 dark:bg-slate-900"
        >
          <dt className="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400">
            {s.label}
          </dt>
          <dd
            className={`mt-1 text-lg tabular-nums ${
              s.className ?? 'text-slate-900 dark:text-white'
            }`}
          >
            {s.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
